import React, { useContext, useState } from 'react';
import Datatable from 'components/common/datatable/datatable';
import softwareUpdateDashboardTransformResults from './softwareUpdateDashboardTransformResults';
import AppContext from 'contexts/appContext';
import SoftwareUpdateService from 'services/softwareUpdateService';
import useAsyncEffect from 'use-async-effect';

export default function SoftwareUpdateDashboardPage(props) {
  const { setAppArea } = useContext(AppContext);

  const [dashboardData, setDashboardData] = useState(null);

  useAsyncEffect(async () => {
    setAppArea(AppContext.Areas.SoftwareUpdate, 'Software Update Dashboard');
    const data = await SoftwareUpdateService.API.getSoftwareUpdateDashboard({
      filters: { quickMenuVersionList: [], spcVersionList: [], posipayVersionList: [], mozartAgentList: [], mozartPluginList: [], siteName: null, siteIds: [] },
      sortBy: null,
      pageOffset: 0,
      pageSize: 100,
      sortAsc: true,
      hierarchyListIds: []
    });
    setDashboardData(data);
  }, []);

  if (!dashboardData) return null;
  const dashboardGridData = softwareUpdateDashboardTransformResults(dashboardData.results);

  return (
    <div className='row justify-content-md-center'>
      <div className='col-12 col-md-10 col-xl-8'>
        <Datatable columns={DashboardGridColumns} data={dashboardGridData} />
      </div>
    </div>
  );
}

const DashboardGridColumns = [
  {
    Header: 'Site',
    accessor: 'hierarchyName',
    sticky: 'left',
    width: 300,
  },
  {
    Header: 'Quick Menu Version',
    accessor: 'QMVersion',
  },
  {
    Header: 'SpcWin Version',
    accessor: 'SPCVersion',
  },
  {
    Header: 'POSiPay Version',
    accessor: 'PAYVersion',
  },
  {
    Header: 'Mozart Agent Version',
    accessor: 'MZAVersion',
  },
  {
    Header: 'Mozart Plugin Version',
    accessor: 'MZPVersion',
  },
  {
    Header: 'Time Attendance Version',
    accessor: 'TAVersion',
  }
];
